export enum PermissionMatchingStrategy {
  All,
  AtLeastOne,
}

export const wildcardQualifier = '*';
